module.exports = __webpack_public_path__ + "static/media/silder_fix_2.989ff902.jpg";